import NotificationMixin from './NotificationMixin';

export default {
  mixins: [NotificationMixin],
  data: () => ({
    downloadTitle: 'Deseja realizar o download?',
    downloadMessage: 'Essa ação irá realizar o download',
    downloadSuccess: 'Sucesso ao realizar download!',
    downloadError: 'Falha ao realizar download!',
  }),
  methods: {
    confirmDownload(request = null, dialogConfig = {}) {
      this.showConfirmDialog(
        this.makeDownloadDialogInfo(dialogConfig),
      ).then((data) => {
        if (data.value) {
          if (request) {
            request();
          }
        }
      });
    },
    makeDownloadDialogInfo(config = {}) {
      return {
        title: this.downloadTitle,
        text: this.downloadMessage,
        ...config,
      };
    },
    createFile(data = [], blobType, exportType, fileName = '') {
      const blob = new Blob(data, { type: blobType });

      this.exportFile(blob, exportType, fileName);
    },
    exportFile(file, exportType, fileName) {
      const link = document.createElement('a');
      link.download = fileName;
      link.href = URL.createObjectURL(file, { type: exportType });
      link.click();
      URL.revokeObjectURL(link.href);
    },
  },
};
